import React from 'react';

export const ErrorBoundaryFallback: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: '"Public Sans", Arial, Helvetica, sans-serif',
        background:
          'linear-gradient(180deg, rgba(0, 0, 0, 0.15), #000), linear-gradient(234deg, #215578 20%, #000)',
        color: '#ffffff',
      }}
    >
      <h1
        style={{
          fontSize: '32px',
          fontWeight: 300,
          marginBottom: '1rem',
          color: '#ffffff',
        }}
      >
        Something went wrong
      </h1>
      <p
        style={{
          fontSize: '16px',
          lineHeight: '150%',
          marginBottom: '2rem',
          color: '#9fa7b8',
          maxWidth: '600px',
        }}
      >
        We&apos;re sorry, but something unexpected happened. Please try refreshing the page or contact
        our <a href='https://support.ouraring.com'>Help center</a> if the problem persists.
      </p>
    </div>
  );
};
